import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import DiscoveryFlow from "@/pages/DiscoveryFlow";
import Success from "@/pages/Success";
import MapView from "@/pages/MapView";
import Gallery from "@/pages/Gallery";
import HeartDetail from "@/pages/HeartDetail";
import Leaderboard from "@/pages/Leaderboard";
import ExplorerProfile from "@/pages/ExplorerProfile";
import HeartsGrid from "@/pages/HeartsGrid";
import About from "@/pages/About";
import Admin from "@/pages/Admin";
import Layout from "@/components/Layout";
import { HeartProvider } from "@/context/HeartContext";

const API = process.env.REACT_APP_BACKEND_URL;

const PageTracker = () => {
  const location = useLocation();
  useEffect(() => {
    const deviceId = localStorage.getItem('hearts_device_id');
    fetch(`${API}/api/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path: location.pathname, device_id: deviceId }),
    }).catch(() => {});
  }, [location.pathname]);
  return null;
};

function App() {
  return (
    <HeartProvider>
      <BrowserRouter>
        <PageTracker />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route element={<Layout />}>
            <Route path="/find" element={<DiscoveryFlow />} />
            <Route path="/upload" element={<Navigate to="/find" replace />} />
            <Route path="/location" element={<Navigate to="/find" replace />} />
            <Route path="/success" element={<Success />} />
            <Route path="/map" element={<MapView />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/heart/:number" element={<HeartDetail />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/explorer/:deviceId" element={<ExplorerProfile />} />
            <Route path="/grid" element={<HeartsGrid />} />
            <Route path="/about" element={<About />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HeartProvider>
  );
}

export default App;
